export const createRegexFromValidationPattern = (validationPattern?: string) => {
  if (!validationPattern) return undefined

  const [_, regex, flags] = validationPattern.split("/")

  return new RegExp(regex, flags)
}
